import { buildMapLink } from '@/utils/event-location.js';
import { getTimezoneName, getDateStr, getTimeRangeStr } from '@/utils/time.js';

// name, address, categories...
const LOCATIONS = [
  ["The Johnson Family Abode", "6 Mill Pond Lane\nPanama City, FL 32404", "Home"],
  ["The Smith Residence", "7103 Gregory Ave\nLongview, TX 75604", "Home"],
  ["The Anderson Homestead", "7837 NW. Woodland Road\nOzone Park, NY 11417", "Home"],
  ["The Williams House", "164 Roberts Drive\nOak Forest, IL 60452", "Home"],
  ["The Martinez Manor", "9065 Ridge Ave\nBettendorf, IA 52722", "Home"],
  ["The Davis Home", "86 Middle River Circle\nBloomington, IN 47401", "Home"],
  ["The Thompson Cottage", "9930 Hill Field Drive\nSaugus, MA 01906", "Home"],
  ["The Brown Family Retreat", "8734 Leatherwood Drive\nGeneva, IL 60134", "Home"],
  ["The Wilson Residence", "767 Rockland Drive\nCarlisle, PA 17013", "Home"],
  ["The Harris Household", "310 Pilgrim Dr\nVilla Rica, GA 30180", "Home"],
  ["The Clark Haven", "891 East York St\nBolingbrook, IL 60440", "Home"],
  ["The Turner Abode", "12 Henry Smith Ave\nEasley, SC 29640", "Home"],
  ["The Lewis Residence", "814 Oklahoma Road\nMorrisville, PA 19067", "Home"],
  ["The Garcia Home", "8121 Swanson Lane\nPottstown, PA 19464", "Home"],
  ["The White Family Estate", "680 Pleasant Rd\nMeadville, PA 16335", "Home"],
  ["The Young House", "9664 Myers Lane\nLibertyville, IL 60048", "Home"],
  ["The Hall Homestead", "437B Birchpond Street\nTucker, GA 30084", "Home"],
  ["The Mitchell Residence", "46 Ridgeview St\nHuntington Station, NY 11746", "Home"],
  ["The Walker Cottage", "973 Cardinal Street\nGrand Blanc, MI 48439", "Home"],
  ["The Turner Family Dwelling", "5 West Westminster Ave\nHenrico, VA 23228", "Home"],
  ["The Perez Home", "72 Overlook Drive\nRomeoville, IL 60446", "Home"],
  ["The Moore Residence", "83 Purple Finch St\nGainesville, VA 20155", "Home"],
  ["The Baker Household", "19 10th Street\nMableton, GA 30126", "Home"],
  ["The Martin Homestead", "9011 Randall Mill Street\nWaxhaw, NC 28173", "Home"],
  ["The Taylor Family Abode", "681 Lilac Rd\nElkhart, IN 46514", "Home"],
  ["The Anderson Apartment", "103 Riverside Avenue\nPowell, TN 37849", "Home"],
  ["The Davis Loft", "90 Lake Street\nLady Lake, FL 32159", "Home"],
  ["The Taylor Townhouse", "10 Indian Summer Road\nGlastonbury, CT 06033", "Home"],
  ["The Brown Family Condo", "8734 Alderwood St\nFond Du Lac, WI 54935", "Home"],
  ["The Johnson Penthouse", "109 Campfire Street\nMedford, MA 02155", "Home"],
  ["The Turner Duplex", "537 Peachtree St\nScarsdale, NY 10583", "Home"],
  ["The Harris Abode", "110 Marsh St\nOlive Branch, MS 38654", "Home"],
  ["The Clark Loft", "96 Shady Street\nPlainfield, NJ 07060", "Home"],
  ["The Lewis Apartment", "7253 East Queen Drive\n Lutherville Timonium, MD 21093", "Home"],
  ["The Baker Bungalow", "300 Beechwood Street\nLoganville, GA 30052", "Home"],
  ["The White Family Penthouse", "793 S. Delaware Rd\nMedia, PA 19063", "Home"],
  ["The Thompson Townhome", "25 Cardinal Lane\nCanyon Country, CA 91387", "Home"],
  ["The Turner Roof Refuge", "35 Manor Station Rd\nDoylestown, PA 18901", "Home"],
  ["The Hall Condo", "4 Tower Court\nNew Hyde Park, NY 11040", "Home"],
  ["The Mitchell Loft", "3 W. Gates Drive\nOpa Locka, FL 33054", "Home"],
  ["The Walker Duplex", "80 Maiden Street\nCary, NC 27511", "Home"],
  ["Jake and Ally's House", "28 Richardson Rd\nCarpentersville, IL 60110", "Home"],
  ["Gray And Anna's Home", "532 E. Ocean St\nMc Lean, VA 22101", "Home"],
  ["Millennium Park", "201 E. Randolph St\nChicago, IL 60601", "Park"],
  ["Golden Gate Park", "501 Stanyan St\nSan Francisco, CA 94117", "Park"],
  ["Balboa Park", "1549 El Prado\nSan Diego, CA 92101", "Park"],
  ["Griffith Park", "4730 Crystal Springs Dr\nLos Angeles, CA 90027", "Park"],
  ["Forest Park", "5595 Grand Dr\nSt. Louis, MO 63112", "Park"],
  ["Piedmont Park", "400 Park Dr NE\nAtlanta, GA 30306", "Park"],
  ["Boston Common", "139 Tremont St\nBoston, MA 02111", "Park"],
  ["Hermann Park", "6001 Fannin St\nHouston, TX 77030", "Park"],
  ["City Park", "1 Palm Dr\nNew Orleans, LA 70124", "Park"],
  ["Fairmount Park", "4231 N Concourse Dr\nPhiladelphia, PA 19131", "Park"],
  ["Prospect Park", "95 Prospect Park W\nBrooklyn, NY 11215", "Park"],
  ["Grant Park", "337 E Randolph St\nChicago, IL 60601", "Park"],
  ["City Park", "2001 Colorado Blvd\nDenver, CO 80205", "Park"],
  ["Discovery Park", "3801 Discovery Park Blvd\nSeattle, WA 98199", "Park"],
  ["Forsyth Park", "2 W Gaston St\nSavannah, GA 31401", "Park"],
  ["Audubon Park", "6500 Magazine St\nNew Orleans, LA 70118", "Park"],
  ["Liberty Park", "600 E 900 S\nSalt Lake City, UT 84105", "Park"],
  ["Franklin Park", "1 Circuit Dr\nBoston, MA 02121", "Park"],
  ["City Park", "2001 Colorado Blvd\nDenver, CO 80205", "Park"],
  ["Harvard University", "Harvard Yard\nCambridge, MA 02138", "University"],
  ["Stanford University", "450 Serra Mall\nStanford, CA 94305", "University"],
  ["Massachusetts Institute of Technology (MIT)", "77 Massachusetts Ave\nCambridge, MA 02139", "University"],
  ["California Institute of Technology (Caltech)", "1200 E California Blvd\nPasadena, CA 91125", "University"],
  ["Yale University", "63 High St\nNew Haven, CT 06511", "University"],
  ["University of Chicago", "5801 S Ellis Ave\nChicago, IL 60637", "University"],
  ["Duke University", "103 Allen Building\nDurham, NC 27708", "University"],
  ["Northwestern University", "633 Clark St\nEvanston, IL 60208", "University"],
  ["Johns Hopkins University", "3400 N Charles St\nBaltimore, MD 21218", "University"],
  ["University of Michigan, Ann Arbor", "500 S State St\nAnn Arbor, MI 48109", "University"],
  ["University of Virginia", "1827 University Ave\nCharlottesville, VA 22903", "University"],
  ["Georgetown University", "3700 O St NW\nWashington, DC 20057", "University"],
  ["Emory University", "201 Dowman Dr\nAtlanta, GA 30322", "University"],
  ["University of California, San Diego (UCSD)", "9500 Gilman Dr\nLa Jolla, CA 92093", "University"],
  ["Rice University", "6100 Main St\nHouston, TX 77005", "University"],
  ["Carnegie Mellon University", "5000 Forbes Ave\nPittsburgh, PA 15213", "University"],
  ["Thomas Jefferson High School for Science and Technology", "6560 Braddock Rd\nAlexandria, VA 22312", "High School"],
  ["Bronx High School of Science", "75 W 205th St\nBronx, NY 10468", "High School"],
  ["Stuyvesant High School", "345 Chambers St\nNew York, NY 10282", "High School"],
  ["Phillips Exeter Academy", "20 Main St\nExeter, NH 03833", "High School"],
  ["Phillips Academy", "180 Main St\nAndover, MA 01810", "High School"],
  ["Walter Payton College Preparatory High School", "1034 N Wells St\nChicago, IL 60610", "High School"],
  ["The Brearley School", "610 E 83rd St\nNew York, NY 10028", "High School"],
  ["Harvard-Westlake School", "3700 Coldwater Canyon Ave\nStudio City, CA 91604", "High School"],
  ["Montgomery Blair High School", "51 University Blvd E\nSilver Spring, MD 20901", "High School"],
  ["The Hotchkiss School", "11 Interlaken Rd\nLakeville, CT 06039", "High School"],
  ["The Dalton School", "108 E 89th St\nNew York, NY 10128", "High School"],
  ["Boston Latin School", "78 Avenue Louis Pasteur\nBoston, MA 02115", "High School"],
  ["Brooklyn Technical High School", "29 Fort Greene Pl\nBrooklyn, NY 11217", "High School"],
  ["Illinois Mathematics and Science Academy", "1500 Sullivan Rd\nAurora, IL 60506", "High School"],
  ["The Harker School", "500 Saratoga Ave\nSan Jose, CA 95129", "High School"],
  ["Northside College Preparatory High School", "5501 N Kedzie Ave\nChicago, IL 60625", "High School"],
  ["Hunter College High School", "71 E 94th St\nNew York, NY 10128", "High School"],
  ["The Potomac School", "1301 Potomac School Rd\nMcLean, VA 22101", "High School"],
  ["Brooklyn Friends School", "375 Pearl St\nBrooklyn, NY 11201", "High School"],
  ["Fiorello H. LaGuardia High School of Music & Art", "100 Amsterdam Ave\nNew York, NY 10023", "High School"],
  ["Lakeside School", "14050 1st Ave NE\nSeattle, WA 98125", "High School"],
  ["The Westminster School", "1424 W Paces Ferry Rd NW\nAtlanta, GA 30327", "High School"],
  ["Thomas S. Wootton High School", "2100 Wootton Pkwy\nRockville, MD 20850", "High School"],
  ["The Spence School", "22 E 91st St\nNew York, NY 10128", "High School"],
  ["Mission San Jose High School", "41717 Palm Ave\nFremont, CA 94539", "High School"],
  ["Myrtle Beach", "110 N Ocean Blvd\nMyrtle Beach, SC 29577", "Beaches"],
  ["Waikiki Beach", "2300 Kalakaua Ave\nHonolulu, HI 96815", "Beaches"],
  ["Miami Beach", "1001 Ocean Dr\nMiami Beach, FL 33139", "Beaches"],
  ["Santa Monica State Beach", "380 Santa Monica Pier\nSanta Monica, CA 90401", "Beaches"],
  ["Coney Island Beach", "1000 Surf Ave\nBrooklyn, NY 11224", "Beaches"],
  ["Jones Beach State Park", "1 Ocean Pkwy\nWantagh, NY 11793", "Beaches"],
  ["Zuma Beach", "30000 Pacific Coast Hwy\nMalibu, CA 90265", "Beaches"],
  ["Rockaway Beach", "8601 Shore Front Pkwy\nRockaway Beach, NY 11693", "Beaches"],
  ["Clearwater Beach", "1 Causeway Blvd\nClearwater, FL 33767", "Beaches"],
  ["Jones Beach", "1 Ocean Pkwy\nWantagh, NY 11793", "Beaches"]
];

// name, categories...
const NAMES = [
  ["Jackson's Pirate Party: Ahoy Mateys!", "Kid's Pirate Birthday"],
  ["Liam's Pirate Adventure", "Kid's Pirate Birthday"],
  ["Zoe's Swashbuckling Soirée", "Pirate Birthday"],
  ["Aiden's Birthday Treasure Hunt", "Kid's Pirate Birthday"],
  ["Ella's Buccaneer Bash", "Pirate Birthday"],
  ["Ava's Pirate Ship Party", "Kid's Pirate Birthday"],
  ["Luna's Pirate Booty Hunt", "Pirate Birthday"],
  ["Mia's Mermaid Soirée", "Kid's Mermaid Birthday"],
  ["Aria's Underwater Celebration", "Kid's Mermaid Birthday"],
  ["Mila's Mermaid Pool Party", "Kid's Mermaid Birthday"],
  ["Liam's Superhero Extravaganza", "Kid's Superhero Birthday"],
  ["Zoey's Superhero Power Party", "Kid's Superhero Birthday"],
  ["Jack's Heroic Birthday Bash", "Kid's Superhero Birthday"],
  ["Oliver's Superhero Adventure", "Kid's Superhero Birthday"],
  ["Ethan's Superhero Spectacular", "Kid's Superhero Birthday"],
  ["Noah's Galactic Gathering: Space Adventure", "Kid's Space Birthday"],
  ["Lara's Out-of-This-World Birthday", "Kid's Space Birthday"],
  ["Benjamin's Blast Off to the Moon", "Kid's Space Birthday"],
  ["Malik's Stellar Adventure", "Kid's Space Birthday"],
  ["Eli's Cosmic Birthday Blast", "Kid's Space Birthday"],
  ["Maya's Astronaut Celebration", "Kid's Space Birthday"],
  ["Niko's Space Cadet Party", "Kid's Space Birthday"],
  ["Leo's Alien Invasion Party", "Kid's Space Birthday"],
  ["Rohan's Martian Odyssey", "Kid's Space Birthday"],
  ["Amara's Celestial Soiree", "Space Birthday"],
  ["Sara's Cosmic Quest", "Kid's Space Birthday"],
  ["Ava's Magical Unicorn Wonderland", "Kid's Unicorn Birthday"],
  ["Isabella's Fairy Tale Fiesta", "Kid's Fairytale Birthday"],
  ["Emma's Enchanted Princess Party", "Kid's Princess Birthday"],
  ["Lily's Unicorn Wonderland Celebration", "Kid's Unicorn Birthday"],
  ["Scarlett's Enchanted Birthday", "Kid's Fairytale Birthday"],
  ["Ella's Princess Soiree", "Kid's Princess Birthday"],
  ["Olivia's Regal Ballroom Bash", "Kid's Princess Birthday"],
  ["Grace's Cinderella Party", "Kid's Princess Birthday"],
  ["Mia's Magical Princess Ball", "Kid's Princess Birthday"],
  ["Emily's Unicorn Wonderland Party", "Kid's Unicorn Birthday"],
  ["Charlotte's Unicorn Fantasy Soiree", "Kid's Unicorn Birthday"],
  ["Harper's Enchanted Unicorn Celebration", "Kid's Unicorn Birthday"],
  ["Scarlett's Unicorn Rainbow Bash", "Kid's Unicorn Birthday"],
  ["Aria's Unicorn Sparkle Spectacular", "Kid's Unicorn Birthday"],
  ["Aiden's Sports Spectacular", "Kid's Sports Birthday"],
  ["Jessica's Sports Extravaganza", "Kid's Sports Birthday"],
  ["Ella's All-Star Celebration", "Kid's Sports Birthday"],
  ["Drew's Soccer Showdown", "Kid's Soccer Birthday"],
  ["Sophia's Gymnastics Gala", "Kid's Gymnastics Birthday"],
  ["William's Basketball Bonanza", "Kid's Basketball Birthday"],
  ["Richard's Sports Showdown", "Kid's Sports Birthday"],
  ["Isabella's Baseball Bash", "Kid's Baseball Birthday"],
  ["Noah's Football Fiesta", "Kid's Football Birthday"],
  ["Liam's Hockey Showdown", "Kid's Hockey Birthday"],
  ["Mason's Mini-Olympics Party", "Kid's Sports Birthday"],
  ["Harper's Birthday Safari Adventure", "Kid's Safari Birthday"],
  ["Aisha's Wild Safari Adventure", "Kid's Safari Birthday"],
  ["Mateo's Jungle Explorer Party", "Kid's Safari Birthday"],
  ["Leila's Safari Expedition", "Kid's Safari Birthday"],
  ["Kai's African Safari Quest", "Kid's Safari Birthday"],
  ["Ella's Safari Animal Trek", "Kid's Safari Birthday"],
  ["Rohan's Safari Discovery", "Kid's Safari Birthday"],
  ["Nadia's Safari Expedition", "Kid's Safari Birthday"],
  ["Amina's Jungle Safari", "Kid's Safari Birthday"],
  ["Harper's Birthday Picnic in the Park", "Picnic Birthday"],
  ["Zara's Picnic Party", "Picnic Birthday"],
  ["Leo's Outdoor Picnic Bash", "Picnic Birthday"],
  ["Nadia's Picnic Adventure", "Picnic Birthday"],
  ["Kai's Sunny Picnic Soiree", "Picnic Birthday"],
  ["Carter's Cake and Ice Cream Party", "Ice Cream Birthday"],
  ["Sophia’s Gelato Get-Together", "Ice Cream Birthday"],
  ["Carter's Birthday Carnival Celebration", "Ice Cream Birthday"],
  ["Nina's Ice Cream Extravaganza", "Ice Cream Birthday"],
  ["Aisha's Sweet Treat Soiree", "Ice Cream Birthday"],
  ["Javier's Sundae Funday", "Ice Cream Birthday"],
  ["Oliver's Outdoor Campfire Celebration", "Kid's Sleepover Birthday"],
  ["Grace's Pink and Purple Pajama Party", "Kid's Sleepover Birthday"],
  ["Chloe's Slumber Soiree Under the Stars", "Kid's Sleepover Birthday"],
  ["Nina's Slumber Party Bash", "Kid's Sleepover Birthday"],
  ["Eli's Pajama Movie Night", "Kid's Sleepover Birthday"],
  ["Aisha's Sleepover Soiree", "Kid's Sleepover Birthday"],
  ["Maya's Birthday Game Night", "Kid's Sleepover Birthday"],
  ["Kai's Pajama Jam", "Kid's Sleepover Birthday"],
  ["Emma's Birthday Fiesta", "Kid's Birthday"],
  ["Liam's Big Birthday Bash", "Kid's Birthday"],
  ["Sarah's Spectacular Birthday Bash", "Kid's Birthday"],
  ["Ava's Birthday Adventure", "Kid's Birthday"],
  ["Sophia's Super Awesome Birthday Party", "Kid's Birthday"],
  ["Olivia's Birthday Bonanza Extravaganza", "Kid's Birthday"],
  ["Mason's Birthday Spectacular", "Kid's Birthday"],
  ["Isabella’s Magical Day", "Kid's Birthday"],
  ["Emma's Birthday Blast", "Kid's Birthday"],
  ["Isabella's Sparkling Birthday Celebration", "Kid's Birthday"],
  ["Drew’s Fun-filled Birthday Party", "Kid's Birthday"],
  ["Anna's Special Birthday Get-Together", "Kid's Birthday"],
  ["Mason's Fantastic Birthday Bash", "Kid's Birthday"],
  ["Sophia's Happy Birthday Gathering", "Kid's Birthday"],
  ["Mia's Birthday Extravaganza", "Kid's Birthday"],
  ["Sarah's Casino Royale Birthday Bash!", "Casino Birthday"],
  ["David's Retro '80s Dance Party Celebration", "Retro Birthday"],
  ["Lisa's Wine Tasting Extravaganza", "Wine Tasting Birthday"],
  ["Michael's Game Night Showdown", "Game Night Birthday"],
  ["Sarah's Birthday Bash", "Birthday"],
  ["David's Birthday Party Celebration", "Birthday"],
  ["Lisa's Birthday Wine Tasting Extravaganza", "Wine Tasting Birthday"],
  ["Michael's Game Night Birthday Showdown", "Game Night Birthday"],
  ["Sophia's Glamour Birthday Soiree", "Birthday"],
  ["James's Birthday Tailgate Party", "Tailgate Birthday"],
  ["Emily's Birthday Garden Soiree", "Garden Birthday"],
  ["Tom's Karaoke Birthday Bash", "Karaoke Birthday"],
  ["Melissa's Art and Wine Canvas Birthday Party", "Art and Wine Birthday"],
  ["Kevin's BBQ and Brews Birthday Bash", "BBQ Birthday"],
  ["Alex's Beach Luau Birthday Fiesta", "Luau Birthday"],
  ["Natalie's Birthday Casino Extravaganza", "Casino Birthday"],
  ["John's Vintage Wine and Cheese Birthday Soiree", "Wine and Cheese Birthday"],
  ["Megan's Paint and Sip Birthday Creative Party", "Paint and Sip Birthday"],
  ["You're Invited: Let's Party!", "Party"],
  ["Get Ready to Celebrate!", "Party"],
  ["Join Us for a Good Time!", "Party"],
  ["It's Time to Par-tee!", "Party"],
  ["Come Celebrate with Us!", "Party"],
  ["Get Your Party Hat Ready!", "Party"],
  ["Dancing Shoes Required!", "Party"],
  ["A Night of Fun and Festivities", "Party"],
  ["Let's Paint the Town Red!", "Party"],
  ["Celebrate in Style!", "Party"],
  ["You're Cordially Invited", "Party"],
  ["Don't Miss the Party of the Year!", "Party"],
  ["A Night to Remember", "Party"],
  ["Get the Party Started!", "Party"],
  ["Join the Celebration!", "Party"],
  ["It's a Party! You're Invited", "Party"],
  ["Save the Date for a Bash!", "Party"],
  ["Party Like There's No Tomorrow!", "Party"],
  ["Celebrate Jake's Graduation!", "Graduation Party"],
  ["Hats Off to the Graduate!", "Graduation Party"],
  ["Join Us for a Graduation Party", "Graduation Party"],
  ["Diploma in Hand, Let's Dance!", "Graduation Party"],
  ["It's Graduation Time!", "Graduation Party"],
  ["Congratulate the Graduate", "Graduation Party"],
  ["Cap and Gown Affair", "Graduation Party"],
  ["Toss the Cap in Style!", "Graduation Party"],
  ["A Bright Future Awaits", "Graduation Party"],
  ["Toast to the Grad!", "Graduation Party"],
  ["Turning Tassels and Celebrating", "Graduation Party"],
  ["Join the Graduation Festivities", "Graduation Party"],
  ["Ready to Conquer the World!", "Graduation Party"],
  ["Dancing into the Future", "Graduation Party"],
  ["Commencement Celebration", "Graduation Party"],
  ["Off to New Adventures!", "Graduation Party"],
  ["The Graduate's Time to Shine", "Graduation Party"],
  ["Join Us to Celebrate Nick's Journey", "Graduation Party"],
  ["Sizzle and Smoke: BBQ Bash!", "BBQ Party"],
  ["Join Us for a Grillin' Good Time!", "BBQ Party"],
  ["BBQ, Brews, and Good Company", "BBQ Party"],
  ["Summer BBQ Extravaganza", "BBQ Party"],
  ["BBQ and Brewskis: Let's Get Grillin'!", "BBQ Party"],
  ["Come Hungry, Leave Happy!", "BBQ Party"],
  ["BBQ Cookout and Fun in the Sun", "BBQ Party"],
  ["Let's Meat and Eat!", "BBQ Party"],
  ["BBQ Picnic in the Park", "BBQ Party"],
  ["BBQ, Friends, and Fun!", "BBQ Party"],
  ["A Bundle of Joy is On the Way!", "Baby Shower"],
  ["Ready to Welcome Baby Charlie!", "Baby Shower"],
  ["Join Us for a Baby Shower!", "Baby Shower"],
  ["Oh Baby! It's Shower Time!", "Baby Shower"],
  ["Honoring Mom and Baby-to-Be", "Baby Shower"],
  ["Tiny Toes and Diapers Galore!", "Baby Shower"],
  ["Get Ready to Celebrate New Life!", "Baby Shower"],
  ["Get Ready to Party, Bride-to-Be!", "Bachelor Party"],
  ["Ladies Night Out: Bachelorette Bash!", "Bachelor Party"],
  ["Last Fling Before the Ring!", "Bachelor Party"],
  ["Honoring the Bride in Style", "Bachelor Party"],
  ["Cheers to the Bride-to-Be!", "Bachelor Party"],
  ["Bachelorette Adventures Await!", "Bachelor Party"],
  ["Cheers to the Groom: Bachelor Bash!", "Bachelor Party"],
  ["Boys' Night Out: Let's Celebrate!", "Bachelor Party"],
  ["One Last Hurrah Before the Big Day", "Bachelor Party"],
  ["Honoring the Groom in Style", "Bachelor Party"],
  ["Groom's Night: Let's Party Hard!", "Bachelor Party"],
  ["A Night of Fun and Revelry", "Bachelor Party"],
  ["Raise a Toast to the Groom!", "Bachelor Party"]
];


function gatherHints(source, i0) {
  const hintsAsSet = new Set();
  for (const row of source)
    for (let i = i0; i < row.length; i++)
      hintsAsSet.add(row[i]);
  const hints = Array.from(hintsAsSet);
  hints.sort();
  return hints;
}


function generateRandomDate(start, end) {
  const d = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  // We're careful to set the time to midnight to make sure the date stays the same if we add less than 24 hours
  d.setHours(0, 0, 0);
  return d;
}

function generateName(hint) {
  const names = NAMES.filter(x => x[1] == hint);
  const [ name ] = names[ Math.floor(Math.random() * names.length) ];
  return { name };
}

const DATETIME_HINT_ATTRS = {
  // Note that day indexes according to 'getDay' start with Sunday as 0
  'Happy hour': { days: [ 3, 4, 5 ], hours: [ '16', '17' ] },
  'Morning': { days: [ 0, 6 ], hours: [ '07', '08', '09', '10' ] },
  'Afternoon': { days: [ 0, 6 ], hours: [ '13', '14', '15' ] },
  'Evening': { days: [ 5, 6 ], hours: [ '17', '18', '19', '20', '21' ] }
};
function generateDatetime(hint) {
  const { days, hours } = DATETIME_HINT_ATTRS[hint];
  let date;
  do {
    date = generateRandomDate(new Date(2022, 0, 1), new Date(2026, 0, 1));
  } while (!days.includes(date.getDay()));
  const date_start = date.toISOString().slice(0, 10);
  const hh = hours[ Math.floor(Math.random() * hours.length) ];
  const mm = Math.random() < .5 ? '00' : '30';
  const time_start = hh + ':' + mm + ':00';
  const fromDate = new Date(date_start + 'T' + hh + ':' + mm);
  const toDate = new Date(fromDate);
  toDate.setTime(toDate.getTime() + 3 * 60 * 60 * 1000);
  const time_end = String((parseInt(hh) + 3) % 24).padStart(2, '0') + ':' + mm + ':00';
  const from = new Date(date_start + 'T' + hh + ':' + mm).toISOString();
  const to = toDate.toISOString();
  const lz_date = getDateStr(fromDate);
  const lz_time_range = getTimeRangeStr(fromDate, toDate);
  const lz_tz_name = getTimezoneName(from, 'short');
  return { date_start, time_start, time_end, from, to, lz_date, lz_time_range, lz_tz_name };
}

function generateLocation(hint) {
  const locations = LOCATIONS.filter(x => x[2] == hint);
  const [ location, address ] = locations[ Math.floor(Math.random() * locations.length) ];
  return { location, address, is_virtual: false, url: buildMapLink(address) };
}

const NAME_HINTS = gatherHints(NAMES, 1);
const DATETIME_HINTS = [ 'Morning', 'Afternoon', 'Evening', 'Happy hour' ];
const LOCATION_HINTS = gatherHints(LOCATIONS, 2);

export { NAME_HINTS, DATETIME_HINTS, LOCATION_HINTS, generateName, generateDatetime, generateLocation };
